import { render, staticRenderFns } from "./settings-organization-tags.vue?vue&type=template&id=23db13b9&scoped=true&"
import script from "./settings-organization-tags.vue?vue&type=script&lang=js&"
export * from "./settings-organization-tags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23db13b9",
  null
  
)

export default component.exports